import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController  } from 'ionic-angular';
import { B07InvoicePage } from '../b07-invoice/b07-invoice';
import { A01LoginPage } from '../a01-login/a01-login';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { B09aProfileInfoPage } from '../b09a-profile-info/b09a-profile-info';
import { ServiceGvariableProvider } from '../../providers/service-gvariable/service-gvariable';
import { B09bBranchInfoPage } from '../b09b-branch-info/b09b-branch-info';
import { B09cCorporateInfoPage } from '../b09c-corporate-info/b09c-corporate-info';
import { B09dSettingInfoPage } from '../b09d-setting-info/b09d-setting-info';

/**
 * Generated class for the B09SettingPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-b09-setting',
  templateUrl: 'b09-setting.html',
})
export class B09SettingPage {

  USER_ID: any;
  USERNAME: any;
  BRANCH_ID: any;
  BRANCH_NAME: any;
  GRP_ID: any;
  GRP_NAME: any;
  CORP_ID: any;
  CORP_NAME: any;
  loading: any;
  errorMessage:any;
  userInfo = [];
  setting = [];
  constructor(public navCtrl: NavController, public navParams: NavParams, public loadingCtrl: LoadingController, public serviceapi:ServiceApiProvider,public global:ServiceGvariableProvider) {

    
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B09SettingPage');
    this.USERNAME = sessionStorage.getItem('username');
    this.USER_ID = sessionStorage.getItem('userid');
    this.BRANCH_ID = sessionStorage.getItem('userbranchid');
    //branch name
    this.GRP_ID = sessionStorage.getItem('usergroupid');
    this.GRP_NAME = sessionStorage.getItem('usergroupname');
    this.CORP_ID = sessionStorage.getItem('usercorpid');
    this.CORP_NAME = sessionStorage.getItem('usercorpname');

    let tbl = ["USER"];
    let column = ["USER_ID"];
    let value = [this.USER_ID];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    if(this.GRP_ID == "2" || this.GRP_ID == "3"  || this.GRP_ID == "4"  || this.GRP_ID == "5") 
    {
      tblkey = ["BRANCH_ID"];
      fktbl = ["BRANCH"];
      fkkey = ["BRANCH_ID"];
    }
    else if(this.GRP_ID == "6" || this.GRP_ID == "7"  || this.GRP_ID == "8") 
    {
      tblkey = ["CORP_ID"];
      fktbl = ["CORPORATE"];
      fkkey = ["CORP_ID"];
    }
   

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    //this.showLoader();

    this.serviceapi.readdata(json_data,"USER","1","1").then((result) => {
    
      let Status = result["Message"];
      if (Status == '1'){
        
        let Records = result["Records"];
        this.userInfo = Records[0];

        if(this.GRP_ID == "1")
        {
          let tbl = ["SETTING"];
          let column = ["ID"];
          let value = ["1"];
          
          let tblkey = ["No"];
          let fktbl = ["No"];
          let fkkey = ["No"];
          let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

          let mydata = Object.assign(jsonitem);
          let json_data = this.serviceapi.json_readdata(mydata,"1");
           this.serviceapi.readdata(json_data,"SETTING","1","1").then((result) => {
            
            let Status = result["Message"];
            if (Status == '1'){
              
              let Records = result["Records"];
              this.setting = Records[0];
      
              //this.loading.dismiss();
              console.log(this.setting);
              
            }
            else {
              this.errorMessage = this.serviceapi.displayErrorMessage(Status);
              //this.loading.dismiss();
            }
          }, (err) => {
            this.errorMessage = "Loading Error. Please try again.";
            //this.loading.dismiss();
          });
        }
        console.log(this.userInfo);
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(Status);
        //this.loading.dismiss();
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      //this.loading.dismiss();

    });
    
  }

  editAccount(){
    this.navCtrl.push(B09aProfileInfoPage, {paramID: this.USER_ID});
  }
  editGroup(){
    if(this.GRP_ID == "2" || this.GRP_ID == "3"  || this.GRP_ID == "4"  || this.GRP_ID == "5") 
    {
      this.navCtrl.push(B09bBranchInfoPage, {paramID: this.BRANCH_ID});
    }
    else if(this.GRP_ID == "6" || this.GRP_ID == "7"  || this.GRP_ID == "8") 
    {
      this.navCtrl.push(B09cCorporateInfoPage, {paramID: this.CORP_ID});
    }
    
  }
  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });

    this.loading.present();
  }
  editSetting()
  {
    this.navCtrl.setRoot(B09dSettingInfoPage, {paramID: "1"});
  }
/*   logout(){
    this.navCtrl.setRoot(A01LoginPage);
  } */
}



// WEBPACK FOOTER //
// ./src/pages/b09-setting/b09-setting.ts